import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { NotificationContainer } from 'react-notifications'
import { useParams } from 'react-router-dom'
import Chart from "react-apexcharts"
import { FaStore, FaCoins, FaImage, FaUsers, FaShoppingCart, FaChartLine } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import businesseservice from "../../../services/business_services"

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props} match={match} />
    }
}

class AdminBusinessDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            business: null,
            users: [],
            purchase_history: [],
            buds: [],
            selectKey: null,
            order: 'asc',
            loading: true,
            nb_credits: 100,
            analytics: null,
            analyticsLoading: false,
            analyticsStart: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
        }
    }

    componentDidMount = async () => {
        await this.loadBusiness()
    }

    loadBusiness = async () => {
        this.setState({ loading: true })
        const { id } = this.props.match.params
        const data = await businesseservice.businessDetails(id)
        const purchase_history = (data.purchase_history || []).sort(
            (a, b) => new Date(b.created_date || 0) - new Date(a.created_date || 0)
        )
        this.setState({ business: data.business, buds: data.buds, purchase_history, users: data.users, loading: false })
        this.loadAnalytics(id)
    }

    loadAnalytics = async (business_uuid) => {
        this.setState({ analyticsLoading: true })
        try {
            const data = await businesseservice.getAnalytics(business_uuid || this.state.business.business_uuid, this.state.analyticsStart)
            this.setState({ analytics: data.profile_views || {}, analyticsLoading: false })
        } catch (e) {
            this.setState({ analyticsLoading: false })
        }
    }

    reorderBuds = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let buds = this.state.buds
        if (order === 'asc')
            buds.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            buds.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ buds })
    }

    reorderPurchases = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let purchase_history = this.state.purchase_history
        if (order === 'asc')
            purchase_history.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            purchase_history.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ purchase_history })
    }

    reorderUsers = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let users = this.state.users
        if (order === 'asc')
            users.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            users.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ users })
    }

    giveCredits = async (nb_credits) => {
        if (this.state.business && this.state.business.business_uuid) {
            await businesseservice.businessCredit(this.state.business.business_uuid, nb_credits)
            window.location.reload()
        }
    }

    render() {
        const levelColors = {
            starter: "bg-gray-100 text-gray-700",
            common: "bg-green-100 text-green-700",
            rare: "bg-blue-100 text-blue-700",
            epic: "bg-purple-100 text-purple-700",
            legendary: "bg-orange-100 text-orange-700",
            mythic: "bg-red-100 text-red-700",
            eternal: "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        };

        return (
            <>
                <AdminLayout 
                    title="Business Details"
                    breadcrumbs={[
                        { label: 'Business', href: '/admin/business' },
                        { label: this.state.business?.business_name || 'Loading...' }
                    ]}
                >
                    {this.state.loading ? (
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                            <p className="text-gray-600">Loading...</p>
                        </div>
                    ) : (
                        <div className="space-y-6">
                            {/* Business Info Card */}
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                        <FaStore className="text-blue-600" />
                                        Merchant Information
                                    </h3>
                                </div>
                                <div className="p-6">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                                        {/* Logo */}
                                        {(this.state.business.logo || this.state.business.logo_url) && (
                                            <div className="flex justify-center items-start">
                                                <img 
                                                    src={this.state.business.logo || this.state.business.logo_url} 
                                                    className="max-h-48 rounded-lg shadow-md border border-gray-200" 
                                                    alt="Merchant logo" 
                                                />
                                            </div>
                                        )}
                                        
                                        {/* Details */}
                                        <div className={`space-y-3 ${(this.state.business.logo || this.state.business.logo_url) ? 'lg:col-span-2' : 'lg:col-span-3'}`}>
                                            <h1 className="text-3xl font-bold text-gray-900">{this.state.business.business_name}</h1>
                                            
                                            <a 
                                                href={this.state.business.website} 
                                                target="_blank" 
                                                rel="noreferrer"
                                                className="text-blue-600 hover:text-blue-800 hover:underline text-lg inline-block"
                                            >
                                                {this.state.business.website}
                                            </a>
                                            
                                            <div className="space-y-2 text-sm">
                                                <div className="flex">
                                                    <span className="font-semibold text-gray-700 w-24">Address:</span>
                                                    <span className="text-gray-900">{this.state.business.address}</span>
                                                </div>
                                                <div className="flex">
                                                    <span className="font-semibold text-gray-700 w-24">City:</span>
                                                    <span className="text-gray-900">{this.state.business.city}</span>
                                                </div>
                                                <div className="flex">
                                                    <span className="font-semibold text-gray-700 w-24">Country:</span>
                                                    <span className="text-gray-900">{this.state.business.country}</span>
                                                </div>
                                                <div className="flex">
                                                    <span className="font-semibold text-gray-700 w-24">Created:</span>
                                                    <span className="text-gray-900">
                                                        {new Date(this.state.business.created_date).toLocaleDateString()}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Description */}
                                            <div className="pt-3 border-t border-gray-200">
                                                <h4 className="font-semibold text-gray-900 mb-2">Description</h4>
                                                {this.state.business.description && this.state.business.description.en ? (
                                                    <div className="space-y-2 text-sm">
                                                        <div>
                                                            <span className="font-medium text-gray-700">EN:</span>
                                                            <p className="text-gray-600 mt-1">{this.state.business.description.en}</p>
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-700">FR:</span>
                                                            <p className="text-gray-600 mt-1">{this.state.business.description.fr}</p>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p className="text-red-500 text-sm">No valid description</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Credits Section */}
                                    <div className="mt-6 pt-6 border-t border-gray-200">
                                        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-lg p-4 border border-amber-200">
                                            <h4 className="text-sm font-semibold text-amber-900 mb-3 flex items-center gap-2">
                                                <FaCoins className="text-amber-600" />
                                                Credits Management
                                            </h4>
                                            <div className="flex flex-wrap items-center gap-4">
                                                <div>
                                                    <span className="text-xs text-amber-700 font-medium">Current Credits:</span>
                                                    <p className="text-2xl font-bold text-amber-900">{this.state.business.credits}</p>
                                                </div>
                                                <div>
                                                    <span className="text-xs text-amber-700 font-medium">Monthly Credits:</span>
                                                    <p className="text-2xl font-bold text-amber-900">{this.state.business.monthly_credits}</p>
                                                </div>
                                                <div className="flex items-center gap-2 ml-auto">
                                                    <input 
                                                        type="number" 
                                                        placeholder="Amount" 
                                                        value={this.state.nb_credits} 
                                                        onChange={(e) => this.setState({ nb_credits: e.target.value })}
                                                        className="w-32 px-3 py-2 border border-amber-300 rounded-lg focus:ring-2 focus:ring-amber-500 outline-none text-sm"
                                                    />
                                                    <button 
                                                        onClick={() => this.giveCredits(this.state.nb_credits)}
                                                        className="px-4 py-2 bg-gradient-to-r from-amber-500 to-yellow-500 text-white rounded-lg hover:from-amber-600 hover:to-yellow-600 transition-all font-medium shadow-md hover:shadow-lg"
                                                    >
                                                        Give Credits
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Buds Section */}
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                        <FaImage className="text-purple-600" />
                                        Distributed Buds ({this.state.buds.length})
                                    </h3>
                                </div>
                                <div className="overflow-x-auto">
                                    <table className="w-full">
                                        <thead className="bg-gray-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-32">Visual</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-36">Level</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Name</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 w-32" onClick={() => this.reorderBuds("nb_distributed")}>
                                                    ⥃ Distributed
                                                </th>
                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {this.state.buds.map((bud, index) => (
                                                <tr key={`bud_${bud.bud_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-700">{index + 1}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <div 
                                                            className="w-16 h-24 rounded-lg bg-cover bg-center shadow-md border border-gray-200"
                                                            style={{ backgroundImage: `url('${bud.bud_info.img_url}')` }}
                                                        />
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className={`inline-block px-3 py-1 rounded-lg text-xs font-medium ${levelColors[bud.bud_info.bud_level]}`}>
                                                            {bud.bud_info.bud_level}
                                                        </span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-medium text-gray-900">{bud.bud_info.bud_name}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-700">{bud.nb_distributed}</span>
                                                    </td>
                                                    <td className="px-4 py-3 text-center">
                                                        <a 
                                                            href={`/admin/buds/details/${bud.bud_uuid}`} 
                                                            target="_blank" 
                                                            rel="noreferrer"
                                                            className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium inline-block"
                                                        >
                                                            Details
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Users Section */}
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 border-b border-gray-200">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                        <FaUsers className="text-green-600" />
                                        Referenced Users ({this.state.users.length})
                                    </h3>
                                </div>
                                {this.state.users.length > 0 && (
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100" onClick={() => this.reorderUsers("firstname")}>
                                                        ⥃ First Name
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100" onClick={() => this.reorderUsers("lastname")}>
                                                        ⥃ Last Name
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100" onClick={() => this.reorderUsers("email_address")}>
                                                        ⥃ Email
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 w-40" onClick={() => this.reorderUsers("last_login_date")}>
                                                        ⥃ Last Seen
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {this.state.users.map(player => (
                                                    <tr key={`player_${player.player_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-4 py-3">
                                                            <span className="font-medium text-gray-900">{player.firstname}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="font-medium text-gray-900">{player.lastname}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-sm text-gray-700">{player.email_address}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-sm text-gray-600">
                                                                {new Date(player.last_login_date).toLocaleDateString()}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* Profile Views Chart */}
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-sky-50 to-blue-50 px-6 py-4 border-b border-gray-200 flex flex-wrap items-center gap-4">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2 flex-1">
                                        <FaChartLine className="text-sky-600" />
                                        Profile Views
                                    </h3>
                                    <div className="flex items-center gap-2">
                                        <label className="text-xs font-medium text-gray-600">From:</label>
                                        <input
                                            type="date"
                                            value={this.state.analyticsStart}
                                            onChange={(e) => this.setState({ analyticsStart: e.target.value }, () => this.loadAnalytics())}
                                            className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-sky-500 outline-none"
                                        />
                                    </div>
                                </div>
                                <div className="p-4">
                                    {this.state.analyticsLoading ? (
                                        <p className="text-gray-500 text-sm text-center py-8">Loading...</p>
                                    ) : this.state.analytics && Object.keys(this.state.analytics).length > 0 ? (
                                        <Chart
                                            type="area"
                                            height={250}
                                            options={{
                                                chart: { id: "profile-views", toolbar: { show: false } },
                                                xaxis: { categories: Object.keys(this.state.analytics), labels: { rotate: -45, style: { fontSize: '11px' } } },
                                                yaxis: { min: 0, labels: { formatter: (v) => Math.round(v) } },
                                                dataLabels: { enabled: false },
                                                stroke: { curve: 'smooth', width: 2 },
                                                fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.4, opacityTo: 0.05 } },
                                                colors: ['#0ea5e9'],
                                                tooltip: { x: { format: 'yyyy-MM-dd' } },
                                                grid: { borderColor: '#f1f5f9' },
                                            }}
                                            series={[{ name: 'Views', data: Object.values(this.state.analytics) }]}
                                        />
                                    ) : (
                                        <p className="text-gray-400 text-sm text-center py-8">No data for this period</p>
                                    )}
                                </div>
                            </div>

                            {/* Purchase History Section */}
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-6 py-4 border-b border-gray-200">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                                        <FaShoppingCart className="text-orange-600" />
                                        Purchase History ({this.state.purchase_history.length})
                                    </h3>
                                </div>
                                {this.state.purchase_history.length > 0 && (
                                    <div className="overflow-x-auto">
                                        <table className="w-full">
                                            <thead className="bg-gray-50 border-b border-gray-200">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 w-48" onClick={() => this.reorderPurchases("purchase_type")}>
                                                        ⥃ Type
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 w-32" onClick={() => this.reorderPurchases("quantity")}>
                                                        ⥃ Quantity
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100 w-32" onClick={() => this.reorderPurchases("total_price")}>
                                                        ⥃ Price
                                                    </th>
                                                    <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-40">Purchase Date</th>
                                                    <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-32">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-200">
                                                {this.state.purchase_history.map(purchase => (
                                                    <tr key={`purchase_${purchase.business_purchase_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                        <td className="px-4 py-3">
                                                            <span className="font-medium text-gray-900">
                                                                {purchase.purchase_type === 0 ? "Bud" : "XP"}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-sm text-gray-700">{purchase.quantity}</span>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <div className="flex flex-col">
                                                                <span className="text-sm font-medium text-gray-900">
                                                                    €{purchase.total_price}
                                                                </span>
                                                                {purchase.cancelled && (
                                                                    <span className="text-xs text-red-600 font-medium">Cancelled</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="px-4 py-3">
                                                            <span className="text-sm text-gray-600">
                                                                {new Date(purchase.created_date).toLocaleDateString()}
                                                            </span>
                                                        </td>
                                                        <td className="px-4 py-3 text-center">
                                                            {purchase.bud_uuid && (
                                                                <a 
                                                                    href={`/admin/buds/details/${purchase.bud_uuid}`} 
                                                                    target="_blank" 
                                                                    rel="noreferrer"
                                                                    className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium inline-block"
                                                                >
                                                                    Bud Details
                                                                </a>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withRouter(AdminBusinessDetails)